import React from 'react';
import OdcSalesPage from './OdcSalesPage';

const OdcSales = () => {
    return <OdcSalesPage />;
};

export default OdcSales;
